var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/icon/32x32-next"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/next"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09113 4.14369C8.09101 4.14362 8.09126 4.14376 8.09113 4.14369L12.2423 6.53436L16.3912 8.93367C16.3911 8.93362 16.3912 8.93372 16.3912 8.93367C18.7581 10.2984 18.7585 13.7109 16.392 15.0759C16.3917 15.0761 16.3923 15.0757 16.392 15.0759L12.2423 17.4757L8.09113 19.8664C5.72558 21.2297 2.76172 19.5206 2.76172 16.79V7.22004C2.76172 4.4761 5.72849 2.78205 8.09113 4.14369ZM7.09228 5.8764C6.05498 5.27843 4.76172 6.02412 4.76172 7.22004V16.79C4.76172 17.9793 6.05789 18.73 7.09228 18.1337L11.2426 15.7435L15.3923 13.3437C16.4249 12.7484 16.4249 11.2616 15.3923 10.6664L7.09228 5.8764Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2422 4.81982C20.7945 4.81982 21.2422 5.26754 21.2422 5.81982V18.1798C21.2422 18.7321 20.7945 19.1798 20.2422 19.1798C19.6899 19.1798 19.2422 18.7321 19.2422 18.1798V5.81982C19.2422 5.26754 19.6899 4.81982 20.2422 4.81982Z",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.c029f86ef07b62dfbc1fdb5dfad1b5d5.svg";
export { ForwardRef as ReactComponent };